<template>
  <div>
    <!-- {{ user }} -->
    <!-- {{ relationships }} -->
    <h3>Assigned Nannies</h3>
    <p v-if="relationships.length === 0">No nannies have been linked to this family.</p>
    <!-- <p>{{ relationships }}</p> -->
    <!-- <p>{{ relationshipCandidates }}</p> -->
    <div class="row">
      <!-- <div v-for="(candidate, index) in relationshipCandidates" :key="candidate.id" class="col-lg-4">
        <div class="p-4" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <img :src="candidate.profile_pic" alt="" style="border-radius: 2px; height: 175px;">
            <h4 class="mt-3" style="margin-bottom: 0;">{{ candidate.first_name }} {{ candidate.last_name }}</h4>
            <p>Status: {{ relationships[index].status }}</p>
            <div v-if="relationships[index].status == 'Interested'">
              <p>Client Interview Preference: {{ relationships[index].text1 }}</p>
              <p>Client Interview Availability: {{ relationships[index].text2 }}</p>
            </div>
            <button class="mylisting-button dark-button mt-2" @click="showUpdateStatusModal(relationships[index], candidate)">Update Status</button>
            <button v-if="$store.getters.candidateEmployerRelationshipStatuses.indexOf(relationships[index].status) >= $store.getters.candidateEmployerRelationshipStatuses.indexOf(`Offer Extended`)" class="mylisting-button dark-button mt-2" @click="showOfferModal(relationships[index])" >View Offer</button>
            <p style="color: red; cursor: pointer;" class="mt-2" @click="showDeleteRelationshipModal(relationships[index])">Delete</p>
          </div>
        </div>
      </div> -->
      <div v-for="relationship in relationships" :key="relationship.id" class="col-lg-4 mb-4">
        <div class="p-4" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <h4 class="mt-3" style="margin-bottom: 0;">{{ relationship.candidate_name }}</h4>
            <p class="mt-2">Status: {{ relationship.status }}</p>
            <div class="mb-2">
              <small v-if="relationship.created_date">Linked: {{ new Date(relationship.created_date).toDateString() }}</small>
            </div>

            <div v-if="relationship.status == 'Interested'">
              <p>Client Interview Preference: {{ relationship.text1 }}</p>
              <p>Client Interview Availability: {{ relationship.text2 }}</p>
            </div>
            <!-- <button class="mylisting-button dark-button mt-2" @click="showUpdateStatusModal(relationships[index], candidate)">Update Status</button> -->
            <button class="mylisting-button dark-button mt-2" @click="showUpdateStatusModal(relationship)">Update Status</button>
            <!-- <button v-if="$store.getters.candidateEmployerRelationshipStatuses.indexOf(relationships[index].status) >= $store.getters.candidateEmployerRelationshipStatuses.indexOf(`Offer Extended`)" class="mylisting-button dark-button mt-2" @click="showOfferModal(relationships[index])" >View Offer</button> -->
            <button v-if="$store.getters.candidateEmployerRelationshipStatuses.indexOf(relationship.status) >= $store.getters.candidateEmployerRelationshipStatuses.indexOf(`Offer Extended`)" class="mylisting-button dark-button mt-2" @click="showOfferModal(relationship)">View Offer</button>
            <!-- <p style="color: red; cursor: pointer;" class="mt-2" @click="showDeleteRelationshipModal(relationships[index])">Delete</p> -->
            <div style="margin-top: 10px; margin-bottom: 5px;">
              <router-link
                :to="{ name: 'Candidate Viewable Dashboard', params: { id: relationship.candidate } }"
                class=""
                target="_blank"
              >View Profile</router-link>
            </div>
            <p style="color: red; cursor: pointer;" class="mt-2" @click="showDeleteRelationshipModal(relationship)">Delete</p>
          </div>
        </div>
      </div>
    </div>

    <button class="mylisting-button dark-button mt-3" @click="showCandidateAssignmentModal()">Add Candidate</button>

    <modal name="candidate-assignment-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h2>Add Candidate to Family</h2>
        <hr>
        <div class="row">
          <div class="col-lg-8">
            <multiselect
              class="mb-2 w-100"
              v-model="candidateSelection"
              :options="candidateEmails"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Select Candidate"
              :max-height= "150"
            ></multiselect>
          </div>
          <div class="col-lg-4">
            <multiselect
              class="mb-2 w-100"
              v-model="candidateEmployerRelationshipStatus"
              :options="candidateEmployerRelationshipStatuses"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Select Status"
              :max-height= "150"
            ></multiselect>
          </div>
        </div>

        <label>Notes for Family about Candidate</label>
        <textarea rows="3" class="form-control" v-model="clientNotes"></textarea>

        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('candidate-assignment-modal')" style="">Close</button>
        <button v-if="candidateSelection && candidateEmployerRelationshipStatus" class="mylisting-button dark-button" @click="postRelationship()" style="float: right;">Add</button>
      </div>
    </modal>

    <modal name="update-status-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- {{ candidate }}
        <hr>
        {{ relationship }} -->
        <div class="center">
          <!-- <img :src="candidate.profile_pic" alt="" style="border-radius: 2px; height: 175px;"> -->
          <!-- <h4 class="mt-3" style="margin-bottom: 0;">{{ candidate.first_name }} {{ candidate.last_name }}</h4> -->
          <h4 class="mt-3" style="margin-bottom: 0;">{{ relationship.candidate_name }}</h4>
          <!-- <p class="">Current Status: {{ relationship.status }}</p> -->
          <multiselect
            class="mb-2 mt-2 w-100 center"
            style="max-width: 300px;"
            v-model="candidateEmployerRelationshipStatus"
            :options="candidateEmployerRelationshipStatuses"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select Status"
            :max-height= "150"
          ></multiselect>
        </div>

        <div class="field-of-fields">
          <label>Notes for Family about Candidate</label>
          <textarea rows="3" class="form-control" v-model="clientNotes"></textarea>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('update-status-modal')">Cancel</button>
        <button class="mylisting-button dark-button mt-2" style="float: right" @click="updateRelationshipStatus(relationship)">Update Status</button>

      </div>
    </modal>

    <modal name="offer-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Offer</h2>
        <div class="field-of-fields">
          <label class="top-label">Pay rate</label>
          <small>For example, $20 per hour or $41,600 per year</small>
          <input type="text" class="form-control" v-model="payRate">
          <label>Contract Duration</label>
          <small>For example, 1 year</small>
          <input type="text" class="form-control" v-model="contractDuration">
          <label>Schedule/Hours</label>
          <small>For example, guaranteeing 40 hours whether worked or not. M-F 8:30AM-5PM</small>
          <textarea rows="3" class="form-control" v-model="daysHours"></textarea>
          <label>Paid Holidays</label>
          <small>For example, New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day and Christmas Day.</small>
          <textarea rows="3" class="form-control" v-model="paidTimeOff"></textarea>
          <label>Paid Vacation</label>
          <small>For example, 10 days</small>
          <input type="text" class="form-control" v-model="paidVacation">
          <label>Paid Sick Days</label>
          <small>For example, 5 days</small>
          <input type="text" class="form-control" v-model="paidSickDays">
          <label>Payment Frequency</label>
          <small>For example, Bi-Weekly</small>
          <input type="text" class="form-control" v-model="paymentFrequency">
          <label>Health Insurance Stipend</label>
          <!-- <small>For example, 10 days</small> -->
          <input type="text" class="form-control" v-model="healthInsurance">
          <label>Mileage Reimbursement</label>
          <small>For on the job travel at the IRS rate of $0.58 per mile.</small>
          <input type="text" class="form-control" v-model="mileageReimbursement">
          <!-- <label>Anticipated start date</label>
          <input type="text" class="form-control" v-model="startDate"> -->
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('offer-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" @click="updateOffer(relationship)" style="float: right;">Update</button>
      </div>
    </modal>

    <modal name="offer-updated-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Offer updated!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('offer-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="candidate-assigned-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Candidate to Family link updated!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('candidate-assigned-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-relationship-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Are you sure you want to remove the link between {{ relationship.candidate_name }} and this family?</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-relationship-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" @click="deleteRelationship(relationship)" style="float: right;">Delete</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      relationships: [],
      relationship: {},
      relationshipCandidates: [],

      candidateEmployerRelationshipStatuses: [],
      candidateEmployerRelationshipStatus: '',

      candidates: [],
      candidateSelection: '',
      candidateEmails: [],
      candidate: {},

      payRate: '',
      contractDuration: '',
      daysHours: '',
      paidTimeOff: '',
      paidVacation: '',
      paidSickDays: '',
      paymentFrequency: '',
      healthInsurance: '',
      mileageReimbursement: '',
      // startDate: '',

      clientNotes: '',
    }
  },
  created() {
    this.candidateEmployerRelationshipStatuses = this.$store.getters.candidateEmployerRelationshipStatuses
    this.getRelationships()
    this.getCandidates()
  },
  methods: {
    getRelationships() {
      axios.get(`/api/relationships/?employer=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.relationships = res.data

          this.relationshipCandidates = []
          for (var relationship in this.relationships) {
            axios.get(`/api/people/?id=${this.relationships[relationship].candidate}`)
              .then(res => {
                console.log(res)
                this.relationshipCandidates.push(res.data[0])
                // let candidateRelationships = this.relationships.filter(relationship => relationship.candidate == res.data[0].id)
                // for (var candidateRelationship in candidateRelationships) {

                // }
              })
              .catch(error => console.log(error));
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCandidates() {
      // axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=${this.$store.getters.candidateActiveStatus}`)
      axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true`)
        .then(res => {
          this.candidates = res.data;
          console.log("Candidates", this.candidates);
          this.candidateEmails = this.candidates.map(
            // candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
            candidate => `${candidate.first_name} ${candidate.last_name} [${candidate.email}]`
          );
        })
        .catch(error => console.log(error));
    },
    showCandidateAssignmentModal() {
      this.candidateSelection = ''
      this.candidateEmployerRelationshipStatus = ''
      this.$modal.show('candidate-assignment-modal')
    },
    getCandidateObject(emailName) {
      //this helper method will allow me to link an invoice to a candidate object
      return this.candidates.filter(element => {
        //since the invoice object does not contain an email, I will have to link the payee_id to the appropriate candidate
        return element.email == this.extractEmail(emailName);
      });
    },
    extractEmail(emailName) {
      // let emailRegExp = /\(([^)]+)\)/; //this will extract the email within parentheses
      let emailRegExp = /\[([^)]+)\]/; //this will extract the email within the square parentheses (switched to square because some people had brackets in their name)
      return emailRegExp.exec(emailName)[1];
    },
    postRelationship() {
      let selectedCandidateObj = this.getCandidateObject(this.candidateSelection)[0];

      console.log(selectedCandidateObj)

      axios.post(`/api/relationships/`, {
        candidate: selectedCandidateObj.id,
        candidate_name: `${selectedCandidateObj.first_name} ${selectedCandidateObj.last_name}`,
        employer: this.user.id,
        employer_name: `${this.user.first_name} ${this.user.last_name}`,
        status: this.candidateEmployerRelationshipStatus,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,

        text7: this.clientNotes,
      })
        .then(res => {
          console.log(res)
          this.getRelationships()
          this.$modal.hide('candidate-assignment-modal')
          this.$modal.show('candidate-assigned-modal')

          this.$store.dispatch('sendEmails',
            {
              subject: `New candidate for you to consider - ${selectedCandidateObj.first_name}`,
              message: `Hello ${this.user.first_name},` + '\n\n' +
              `We have found a great new candidate for you to consider: ${selectedCandidateObj.first_name}!\n` +
              `Please log into your dashboard (${this.$store.getters.platformLoginURL}) to view their profile and let us know what you think.\n\n` +
              `Sincerely,\nThe ${this.$store.getters.agencyHumanName} Team`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.user.email],
              reply: this.$store.getters.agencyReplyEmail,
              userID: this.user.id,
            }
          )
        })
        .catch(error => console.log(error));
    },
    // showUpdateStatusModal(relationship, candidate) {
    showUpdateStatusModal(relationship) {
      this.$modal.show('update-status-modal')
      this.relationship = relationship
      this.candidateEmployerRelationshipStatus = relationship.status
      // this.candidate = candidate

      this.clientNotes = relationship.text7
    },
    updateRelationshipStatus(relationship) {
      axios.patch(`/api/relationships/${relationship.id}/`, {
        status: this.candidateEmployerRelationshipStatus,

        text7: this.clientNotes,
      })
        .then(res => {
          // console.log(res)
          this.$modal.hide('update-status-modal')
          this.getRelationships()
        })
        .catch(error => console.log(error))
    },
    showOfferModal(relationship) {
      this.relationship = relationship
      this.daysHours = relationship.text3
      this.payRate = relationship.text4
      this.paidTimeOff = relationship.text5
      // this.startDate = relationship.text6
      this.contractDuration = relationship.text6
      this.paidVacation = relationship.text8
      this.paidSickDays = relationship.text9
      this.paymentFrequency = relationship.text10
      this.healthInsurance = relationship.text11
      this.mileageReimbursement = relationship.text12
      this.$modal.show('offer-modal')
    },
    updateOffer() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text3: this.daysHours,
        text4: this.payRate,
        text5: this.paidTimeOff,
        // text6: this.startDate,
        text6: this.contractDuration,
        // text7 got taken by admin notes for client
        text8: this.paidVacation,
        text9: this.paidSickDays,
        text10: this.paymentFrequency,
        text11: this.healthInsurance,
        text12: this.mileageReimbursement,
        // status: 'Offer Extended',
      })
        .then(res => {
          this.$modal.hide('offer-modal')
          this.$modal.show('offer-updated-modal')
          this.getRelationships()
        })
        .catch(error => console.log(error))
    },
    showInterviewModal(relationship) {
      this.relationship = relationship
      this.date = null
      this.startHour = 1
      this.startMinute = '00'
      this.startAMPM = 'AM'
      this.$modal.show('interview-modal')
    },
    setInterview() {
      // Interview Time -------------------------------
      this.startHour = parseInt(this.startHour)
      if (this.startHour == 12) {
        this.startHour -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour)
        this.startHour += 12
        console.log(this.startHour)
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour)

      let interview = this.dateInDjangoFormat(this.date)+'T'+this.startHour+':'+this.startMinute+':00'
      // -------------------------------------------

      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        date1: interview,
        interview_type: this.interviewType,
      })
        .then(res => {
          // console.log(res)
          this.$modal.hide('interview-modal')
          this.getRelationships()
        })
        .catch(error => console.log(error))
    },
    showDeleteRelationshipModal(relationship) {
      this.relationship = relationship
      this.$modal.show('delete-relationship-modal')
    },
    deleteRelationship(relationship) {
      axios.delete(`/api/relationships/${relationship.id}`)
        .then(res => {
          console.log(res)
          this.$modal.hide('delete-relationship-modal')
          this.getRelationships()
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/CandidateEmployerRelationshipManager.vue